// Define the types for headers
type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
  isNumeric?: boolean;
};

// Define the headers for the Stakeholders list
export const STAKEHOLDERS_HEADERS: Header[] = [
  {
    key: "entityname",
    label: "Entity Name",
    sortable: true,
    style: { width: "13%" },
  },
  {
    key: "stakeholdertypedesc",
    label: "Type",
    sortable: true,
    style: { width: "14%" },
  },
  {
    key: "stakeholderaddress",
    label: "Primary Address",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "phonenumber",
    label: "Phone Number",
    sortable: true,
    style: { width: "13%" },
    isNumeric: true,
  },
  {
    key: "contactfullname",
    label: "Contact Full Name",
    sortable: true,
    style: { width: "15%" },
  },
  {
    key: "contactemailaddress",
    label: "Contact Email Address",
    sortable: false,
    style: { width: "16%" },
  },
  {
    key: "contactphonenumber",
    label: "Contact Phone Number",
    sortable: false,
    style: { width: "17%" },
    isNumeric: true,
  },
  {
    key: "actions",
    label: "Action",
    style: { width: "6%" },
  },
];

export const STAKEHOLDERS_CONTACT: Header[] = [
  { key: "contactfullname", label: "Contact Details", sortable: false },
  { key: "emailaddress", label: "Email Id", sortable: false },
  { key: "phonenumber", label: "Phone No", sortable: false },
  { key: "faxnumber", label: "Fax No", sortable: false },
  { key: "contactusername", label: "Credential Details", sortable: false },
  // { key: "contactPhoneNumber", label: "Contact Phone Number", sortable: true },
  {
    key: "actions",
    label: "Action",
  },
];
export const STAKEHOLDERS_ADDRESS = [
  // {
  //   key: 'address_type',
  //   label: 'Address Type',
  //   columns: [{key: 'addresstypedesc', label: ''}],
  //   style: {width: '12%'},
  // },
  {
    key: "address_details",
    label: "Address Details",
    columns: [
      { key: "addressline1", label: "Address Line #1", style: { width: "7%" } },
      { key: "addressline2", label: "Address Line #2", style: { width: "7%" } },
      { key: "addressline3", label: "Address Line #3", style: { width: "7%" } },
      { key: "city", label: "City", style: { width: "7%" } },
      { key: "country", label: "Country", style: { width: "7%" } },
      { key: "state", label: "State", style: { width: "7%" } },
      { key: "zipcode", label: "Zip Code", style: { width: "7%" } },
    ],
  },
  {
    key: "contact_details",
    label: "Communication Details",
    columns: [
      { key: "phonenumber", label: "Ph No", style: { width: "13%" } },
      { key: "faxnumber", label: "Fax No", style: { width: "13%" } },
    ],
  },
  {
    key: "actions",
    label: "Action",
    columns: [{ key: "actions", label: "", style: { width: "7%" } }],
  },
];

export const CONTACT_LOG_HEADERS: Header[] = [
  { key: "createdbyname", label: "Created By" },
  { key: "createddate", label: "Created On" },
  { key: "modifiedbyname", label: "Last Modified By" },
  { key: "modifieddate", label: "Last Modified On" },
];

export const STAKEHOLDER_LOG_HEADERS: Header[] = [
  { key: "createdby", label: "Created By" },
  { key: "createdon", label: "Created On" },
  { key: "modifiedby", label: "Last Modified By" },
  { key: "modifiedon", label: "Last Modified On" },
];

export const STAKEHOLDER_LOG_ADDRESS: Header[] = [
  { key: "createdby", label: "Created By" },
  { key: "createddate", label: "Created On" },
  { key: "modifiedby", label: "Last Modified By" },
  { key: "modifieddate", label: "Last Modified On" },
];
export const STAKEHOLDER_CLINIC_ADDRESS: Header[] = [
  { key: "createdByFullName", label: "Created By" },
  { key: "createdDate", label: "Created On" },
  { key: "modifiedByFullName", label: "Last Modified By" },
  { key: "modifiedDate", label: "Last Modified On" },
];

export const STAKEHOLDERS_QME_CONTACT: Header[] = [
  { key: "contactfullname", label: "Contact Details", sortable: false },
  // { key: "specialization", label: "Specialization", sortable: false },

  // { key: "experienceinyears", label: "Experience", sortable: false },
  { key: "defaultWebRoleDesc", label: "User Role", sortable: false },
  { key: "locationcount", label: "Location Count", sortable: false },
  { key: "emailaddress", label: "Email Id", sortable: false },
  { key: "phonenumber", label: "Phone No", sortable: false },
  { key: "faxnumber", label: "Fax No", sortable: false },
  { key: "contactusername", label: "Credential Details", sortable: false },
  { key: "isAllowScheduling", label: "Allow Scheduling", sortable: false },
  {
    key: "actions",
    label: "Action",
  },
];

export const STAKEHOLDERS_CLINIC_CONTACT: Header[] = [
  {
    key: "providerName",
    label: "Location",
    sortable: false,
    style: { width: "28%" },
  },
  {
    key: "providerAddress",
    label: "Address Line 1",
    sortable: false,
    style: { width: "18%" },
  },
  {
    key: "emailAddress",
    label: "Email Id",
    sortable: false,
    style: { width: "12%" },
  },
  {
    key: "phoneNumber",
    label: "Phone No",
    sortable: false,
    style: { width: "12%" },
  },
  // {
  //   key: "faxNumber",
  //   label: "Fax No",
  //   sortable: false,
  //   style: { width: "13%" },
  // },
  {
    key: "locationContactName",
    label: "Contact Name",
    sortable: false,
    style: { width: "13%" },
  },

  // { key: "contactPhoneNumber", label: "Contact Phone Number", sortable: true },
  {
    key: "actions",
    label: "Action",
    style: { width: "7%" },
  },
];

export const PARTY_NOTIFICATION_PREFERENCE_HEADERS: Header[] = [
  {
    key: "srNo",
    label: "Sr No.",
    style: { width: "5%" },
  },
  {
    key: "eventName",
    label: "Notification Event(s)",
    style: { width: "20%" },
  },
  {
    key: "isEmailNotification",
    label: "Email Notification",
    style: { width: "15%" },
  },
  {
    key: "isSmsNotification",
    label: "SMS Notification",
    style: { width: "15%" },
  },
  {
    key: "isInAppNotification",
    label: "In-App Notification",
    style: { width: "15%" },
  },

  {
    key: "uploadedBy",
    label: "Last Updated By",
    style: { width: "15%" },
  },
  {
    key: "uploadedOn",
    label: "Last Updated On",
    style: { width: "15%" },
  },
];
